import { render, staticRenderFns } from "./create-artist-profile.vue?vue&type=template&id=8c65c798&scoped=true"
import script from "./create-artist-profile.vue?vue&type=script&lang=js"
export * from "./create-artist-profile.vue?vue&type=script&lang=js"
import style0 from "./create-artist-profile.vue?vue&type=style&index=0&id=8c65c798&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c65c798",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c65c798')) {
      api.createRecord('8c65c798', component.options)
    } else {
      api.reload('8c65c798', component.options)
    }
    module.hot.accept("./create-artist-profile.vue?vue&type=template&id=8c65c798&scoped=true", function () {
      api.rerender('8c65c798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/create-artist-profile.vue"
export default component.exports